// Animation configuration for scroll sections
// Adjust these values to control animation speed and behavior

export const ANIMATION_CONFIG = {
    // Section navigation (horizontal slide between sections)
    sectionTransition: {
        duration: 0.8, // seconds - increased for smoother vertical transitions
        ease: 'power2.inOut'
    },

    // Child navigation (vertical slide within section)
    childTransition: {
        duration: 0.6, // seconds - increased for smoother horizontal transitions
        ease: 'power2.inOut'
    },

    // Component animations (when slide becomes active)
    components: {
        // Full media section (fade + scale)
        fullMedia: {
            duration: 0.6, // seconds (was 1.2)
            ease: 'power2.out'
        },

        // Text section (fade + slide up)
        textSection: {
            duration: 0.5, // seconds (was 1.0)
            delay: 0.1, // seconds (was 0.2)
            ease: 'power3.out'
        },

        // Custom media section (fade + scale with bounce)
        customMedia: {
            duration: 0.5, // seconds (was 1.0)
            ease: 'back.out(1.2)'
        },

        // Split section (left/right slide in)
        splitSection: {
            duration: 0.5, // seconds (was 0.8)
            ease: 'power2.out'
        }
    },

    // Mouse wheel debounce
    wheelDebounce: 50 // milliseconds
};
